export enum TRDAStatus {
    SENT = 'SENT',
    SEEN = 'SEEN',
    APPROVED = 'APPROVED',
    REJECTED = 'REJECTED',
    COMPLETED = 'COMPLETED'
}